/*
 *******************************************************************************
 * 
 *  Filename:   ./config/routesCompanies.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Routes for Company Components
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 9:55 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import React from 'react';
import Loadable from 'react-loadable';

function Loading() {
    return <div>Loading...</div>;
}

export const Companies = Loadable({
    loader: () => import('../containers/Companies/CompanyListContainer'),
    loading: Loading,
});

export const CompanyEdit = Loadable({
    loader: () => import('../containers/Companies/CompanyEditContainer'),
    loading: Loading,
});

export const CompanyStatuses = Loadable({
    loader: () => import('../containers/CompanyStatuses/CompanyStatusListContainer'),
    loading: Loading,
});

export const CompanyStatusEdit = Loadable({
    loader: () => import('../containers/CompanyStatuses/CompanyStatusEditContainer'),
    loading: Loading,
});


// WEBPACK FOOTER //
// ./src/config/routesCompanies.js